import request from '../../api/request';
import { PaginationRequestType } from '../../types/paginationRequestType';
import { SectionStateEnum } from './types';

const ENDPOINTS = {
  SECTIONS_FORM: `maintainers-portal/non-structured-period-close/form`,
  SECTIONS: `maintainers-portal/non-structured-period-close`,
};

export const ITEMS_PER_PAGE_DEFAULT = 10;

export async function getSectionsForm() {
  const response = await request<{
    years: { id: string; name: string }[];
    currentYear: { id: string; name: string };
    schools: { id: number; name: string }[];
    campuses: { id: number; name: string }[];
    modalities: { id: number; name: string }[];
  }>(ENDPOINTS.SECTIONS_FORM);
  if (response.error) {
    throw response.error;
  }
  return response.data;
}

export async function getSections(params: {
  year?: string;
  schoolId?: number;
  campusId?: number;
  modalityId?: number;
  searchSection?: string;
  searchCourse?: string;
  state: SectionStateEnum;
  page: number;
}) {
  const response = await request<PaginationRequestType<any>>(
    ENDPOINTS.SECTIONS,
    {
      params: {
        ...params,
        itemsPerPage: ITEMS_PER_PAGE_DEFAULT,
        page: params.page - 1,
      },
    },
  );
  if (response.error) {
    throw response.error;
  }
  return response.data;
}
